import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import useClock from "./hooks/useClock";
import { getNow } from "./utils/shared/time";
import { useEvents } from "./context/EventsContext";
import backArrow from "../assets/backArrow.svg";
import searchIcon from "../assets/searchEvents.svg";
import DAZNBusinessHorizontalWhite from "../assets/DAZNBusinessHorizontalWhite.svg";
import MarketingButton from "./components/MarketingButton";
import "./epg.scss";

const BackButton = ({ goBack }) => {
    const { ref, focused } = useFocusable({
        focusKey: "BACK_BUTTON",
        onEnterPress: goBack,
    });

    return (
        <button ref={ref} className={`backBtn ${focused ? "focused" : ""}`} onClick={goBack} aria-label="Back" tabIndex={0}>
            <img src={backArrow} alt="Back" />
        </button>
    );
};

const SearchButton = ({ onOpen }) => {
    const { ref, focused } = useFocusable({
        focusKey: "SEARCH_BUTTON",
        onEnterPress: onOpen,
    });

    return (
        <button ref={ref} className={`searchBtn ${focused ? "focused" : ""}`} onClick={onOpen} aria-label="Search" tabIndex={0}>
            <img src={searchIcon} alt="" />
            <span className="searchBtn__label">Search</span>
        </button>
    );
};

const EPGHeader = ({ goBack, closeEPG, showMarketingButton, onOpenSearch, showSearch }) => {
    const [currentTime, setCurrentTime] = useState(getNow());
    const { showFiltered } = useEvents();

    useClock(setCurrentTime);

    const displayTime = useMemo(() => currentTime.format("hh:mm A"), [currentTime]);

    const rightSection = useMemo(
        () => (
            <div className="rightButtons">
                {!showSearch && <SearchButton onOpen={onOpenSearch} />}
                {showMarketingButton && <MarketingButton closeEPG={closeEPG} />}
                <h2>{displayTime}</h2>
            </div>
        ),
        [showMarketingButton, displayTime, closeEPG, onOpenSearch, showSearch]
    );

    return (
        <div className="headerInfo">
            {(showFiltered || showSearch) ? <BackButton goBack={goBack} /> : <img className="brandDazn" src={DAZNBusinessHorizontalWhite} alt="DAZN" />}
            {rightSection}
        </div>
    );
};

export default EPGHeader;
